import { Draft } from "immer";
import validateAction from "./action";
import validateTarget from "./target";
import validateCloudStorage from "./cloudStorage";
import validateStorageFilepath from "./storageFilepath";
import validateApprovalSteps from "./approvalSteps";
import { verifyIfCanSave } from "../verifyIfCanSave";
import validateSendDelay from "./sendDelay";

import { NOTIFICATION_LIMITS } from "@dashboard-v3/shared";
import { State, Step } from "../../types";
import { getSmimeActionState } from "pages/Rules/Form/context/ruleSelectors";

export default function validateStep(step: Step, draft: Draft<State>) {
  switch (step) {
    case "action":
      validateAction(draft);
      verifyIfCanSave(draft);
      break;
    case "target":
      validateTarget(draft);
      verifyIfCanSave(draft);
      break;
    case "cloudStorage":
      validateCloudStorage(draft);
      verifyIfCanSave(draft);
      break;
    case "storageFilepath":
      validateStorageFilepath(draft);
      verifyIfCanSave(draft);
      break;
    case "approvalSteps":
      validateApprovalSteps(draft);
      verifyIfCanSave(draft);
      break;
    case "sendDelay":
      validateSendDelay(draft);
      verifyIfCanSave(draft);
      break;
    case "smimeAction":
      const { smimeActions, failedAction } = getSmimeActionState(draft.rule);
      let isValid = false;
      const isValidActions = Boolean(smimeActions.length);

      if (isValidActions && failedAction.addSubjectInvalidSmime) {
        isValid =
          Boolean(failedAction.subjectInvalidSmime) &&
          failedAction.subjectInvalidSmime.length <=
            NOTIFICATION_LIMITS.SUBJECT_TAG;
      } else {
        isValid = isValidActions;
      }

      draft.steps.smimeAction.valid = isValid;
      verifyIfCanSave(draft);
  }
}
